import { render, staticRenderFns } from "./ProductCreateEdit.vue?vue&type=template&id=2eb9a544&scoped=true&"
import script from "./ProductCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb9a544",
  null
  
)

export default component.exports